export default "__VITE_ASSET__BuFByuxy__"